<template>
  <div id="main_layout" :class="$mq">
    <div id="main_content">
      <slot></slot>
    </div>

    <div id="main_footer_container">
      <div id="footer">
        <img class="landing_border" src="@/assets/imgs/border.png" v-if="mq_gt_xs" />
  
        <div id="footer_container">
          <div id="footer1" class="column">
            <img src="@/assets/imgs/logo.png" />
  
            <p><b>Dev Null Productions</b></p>
            <p>48 Wall Street, #1100</p>
            <p>NYC, New York 10005</p>
  
            <div id="copyright" v-if="mq_gt_xs">
              <p>© Copyright 2025</p>
              <p><a href="https://devnullprod.com">Dev Null Productions</a></p>
              <p>All Rights Reserved</p>
            </div>
          </div>
  
          <div id="footer2" class="column">
            <!--<a href="https://devnullprod.com/">
              <img id="playtest2" src="@/assets/imgs/playtesting.png" />
            </a>-->
  
            <div id="channels_container">
              <p><b>Our channels</b></p>
              <div id="channels">
                <a href="https://instagram.com/devnullprod">
                  <img src="@/assets/imgs/IG.svg" />
                </a>
  
                <a href="https://x.com/devnullprod">
                  <img src="@/assets/imgs/X.svg" />
                </a>
  
                <a href="https://www.youtube.com/@devnullprod">
                  <img src="@/assets/imgs/YT.svg" />
                </a>
  
                <a href="https://twitch.com/devnullprod">
                  <img src="@/assets/imgs/Twitch.svg" />
                </a>
  
                <a href="https://store.steampowered.com/app/3507360/The_Longest_Tale/">
                  <img src="@/assets/imgs/Steam.svg" />
                </a>
  
                <a href="https://www.linkedin.com/company/devnullprod">
                  <img src="@/assets/imgs/linkedin.svg" />
                </a>
  
                <a href="https://www.facebook.com/people/Dev-Null-Prod/100063785149118/">
                  <img src="@/assets/imgs/FB.svg" />
                </a>
  
                <a href="https://www.tiktok.com/@devnullprod">
                  <img src="@/assets/imgs/TikTok.svg" />
                </a>
  
                <a href="https://bsky.app/profile/devnullprod.bsky.social">
                  <img src="@/assets/imgs/BlueSky.svg" />
                </a>
  
                <a href="https://www.threads.net/@devnullprod">
                  <img src="@/assets/imgs/Threads.svg" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  name: 'MainLayout',

  props : {
    section : {
      type : String,
      required : true
    },
  }
}
</script>

<style scoped lang="scss">
@import "@/scss/custom.scss";

a{
  color: $off-white;
}

a.disabled{
  pointer-events: none;
  cursor: default;
}

a.disabled img{
  filter: brightness(50%);
}

#main_layout{
  position: relative;
  min-height: 100%;
  background-color: $black;
  color: $white;
  font-family: Alliance No2;
}

#main_content{
  position: relative;
}

#main_header_container{
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
}

#main_footer_container{
  width: 100%;
  position: relative;
}

#footer{
  margin-top: 150px;
}

#main_layout.xs #footer{
  margin-top: unset;
  align-self: flex-start;
  padding-left: 15px;
  width: 100%;
}

#footer_container{
  display: flex;
  justify-content: space-around;
  text-align: left;
  padding-top: 25px;

  @media screen and (max-width: 385px) {
    justify-content: unset;
  }
}

#main_layout.xs #footer_container{
  padding-top: unset;
}

#footer_container p{
  margin-bottom: 0;
  font-size: 12px;
}

#footer1 img{
  width: 150px;
  position: relative;
  left: -15px;
}

#copyright{
  margin-top: 50px;
}

#main_layout.xs #copyright{
  margin-top: 15px;
}

#copyright p{
  margin-bottom: 0;
  text-align: left;
}

#footer2 h3{
  margin-top: 15px;
  font-size: 24px;
}

#footer2 a{
  color: $white;
}

#footer2 a:hover{
  text-decoration: none;
}

#footer2 img{
  margin-top: 25px;
}

#main_layout.xs #footer2 #playtest2{
  width: 185px;
}

#channels_container{
  padding: 15px;
  margin-top: 15px;
  background-image: linear-gradient(-179deg, $gray-1, $black 30%);
}

#channels{
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 175px;
  gap: 17px;
}

#main_layout.xs #channels{
  max-width: 155px;
}

#copyright{
  margin-bottom: 15px;
}
</style>
